import { Avatar, Button, Space, Timeline } from "antd";
import { onMessage } from "firebase/messaging";
import moment from "moment";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import NetworkIcon from "../../../assets/icons/NetworkIcon";
import SuccessTimelineIcon from "../../../assets/icons/SuccessTimelineIcon";
import { generateToken, messaging } from "../../../helpers/firebaseConfig";
import useModal from "../../../hooks/useModal";
import { networkLogViewAsync } from "../../../store/features/NP/network/networkAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CustomModalProps } from "../../../types";
import { GetAllTowerData } from "../../../types/redux";
import { capitalize, firstChar } from "../../../utils/string";
import { formatDate, formatTime, formatTo12Hour } from "../../../utils/time";
import CustomModal from "../../common/CustomModal";
import Loader from "../../common/Loader";
import LocatorListItem from "../../ui/LocatorListItem";
import DistanceCalculator from "./DistanceCalculator";
import ViewImages from "./ViewImages";
import WorkDurationModal from "./WorkDurationModal";
import ViewSingleImage from "./ViewSingleImage";

type Props = {
  locatorTitle: string;
  locatorChildren?: ReactNode;
  data?: any;
  type?: "SINGLE_LIST";
} & CustomModalProps;

type ImageType = {
  open: boolean;
  type?: "ENTRY" | "EXIST" | "REACHEDLOCATION" | "STARTJOURNEY";
};

export default function ViewLog({
  locatorTitle,
  locatorChildren,
  handleClose,
  data,
  type,
  ...rest
}: Props) {
  const [selectedOperator, setSelectedOperator] = useState<"gp" | "robi" | "">(
    ""
  );
  const dispatch = useAppDispatch();
  const { open, handleOpen, toggle } = useModal();
  const ticketData = data as GetAllTowerData;
  const [openImg, setOpenImg] = useState<ImageType | null>(null);
  const [openSingleImg, setOpenSingleImg] = useState<ImageType | null>(null);
  const { viewLoading, logNetworks } = useAppSelector((state) => state.network);

  // const time = {
  //   start: ticketData?.towerTicketLogData?.pgStart?.time,
  //   end: ticketData?.towerTicketLogData?.pgOff?.time,
  //   rest:
  //     ticketData?.towerTicketLogData?.result?.reduce(
  //       (acc, curr) => acc + (curr?.minutesOfRestTime || 0),
  //       0
  //     ) || 0,
  // };

  // console.log(ticketData?.towerTicketLogData?.result);

  // const totalWorkingTime =
  //   time?.start && time?.end
  //     ? calculateMinutes(time?.start, time?.end) - time?.rest
  //     : 0;

  // console.log(openImg);

  // ✅ Default show whichever exists first (GP > Robi)
  useEffect(() => {
    if (logNetworks?.pgByOperator?.gp) {
      setSelectedOperator("gp");
    } else if (logNetworks?.pgByOperator?.robi) {
      setSelectedOperator("robi");
    }
  }, [logNetworks]);

  // ✅ Choose data dynamically
  const currentData =
    logNetworks?.pgByOperator?.[selectedOperator as "gp" | "robi"];

  const timelineData = [
    {
      id: 0,
      title: "TT raised at",
      date: logNetworks?.towerTicketId?.createdAt
        ? formatDate(logNetworks?.towerTicketId?.createdAt)
        : "",
      time: logNetworks?.towerTicketId?.createdAt
        ? formatTime(logNetworks?.towerTicketId?.createdAt, "h:mm A")
        : "",
      show: true,
    },
    {
      id: 1,
      title: "Accept task request",
      date: logNetworks?.createdAt ? formatDate(logNetworks?.createdAt) : "",
      time: logNetworks?.createdAt
        ? formatTime(logNetworks?.createdAt, "h:mm A")
        : "",
      show: logNetworks?.tower ? true : false,
    },
    {
      id: 2,
      title: (
        <div className="flex items-center gap-2">
          <span>Going to tower location</span>
          {logNetworks?.startJourney?.photo ? (
            <div
              className={`status border-none ${
                true
                  ? "status-info cursor-pointer !text-white !bg-[#ccc]"
                  : "status-info !text-gray-400"
              }`}
              onClick={() =>
                setOpenSingleImg({
                  open: true,
                  type: "STARTJOURNEY",
                })
              }
            >
              View
            </div>
          ) : null}
        </div>
      ),
      date: logNetworks?.startJourney?.date
        ? formatDate(logNetworks?.startJourney?.date)
        : "",
      time: logNetworks?.startJourney?.time || "",
      show:
        logNetworks?.tower && logNetworks?.startJourney?.date ? true : false,
    },
    {
      id: 3,
      title: (
        <div className="flex items-center gap-2">
          <span>Reached to location</span>
          {logNetworks?.reachedLocation?.photo ? (
            <div
              className={`status border-none ${
                true
                  ? "status-info cursor-pointer !text-white !bg-[#ccc]"
                  : "status-info !text-gray-400"
              }`}
              onClick={() =>
                setOpenSingleImg({
                  open: true,
                  type: "REACHEDLOCATION",
                })
              }
            >
              View
            </div>
          ) : null}
        </div>
      ),
      date: logNetworks?.reachedLocation?.date
        ? formatDate(logNetworks?.reachedLocation?.date)
        : "",
      time: logNetworks?.reachedLocation?.time || "",
      show:
        logNetworks?.tower &&
        logNetworks?.startJourney?.date &&
        logNetworks?.reachedLocation?.date
          ? true
          : false,
    },
    {
      id: 4,
      title: (
        <div className="flex items-center gap-2">
          <span>Verify Service - 1</span>
          {logNetworks?.entryImages?.length ? (
            <div
              className={`status border-none ${
                true
                  ? "status-info cursor-pointer !text-white !bg-[#ccc]"
                  : "status-info !text-gray-400"
              }`}
              onClick={() =>
                setOpenImg({
                  open: true,
                  type: "ENTRY",
                })
              }
            >
              View
            </div>
          ) : null}
        </div>
      ),
      pgCheck: logNetworks?.checkList?.map((el) => el?.name),
      show:
        logNetworks?.tower &&
        logNetworks?.startJourney?.date &&
        logNetworks?.reachedLocation?.date &&
        logNetworks?.entryImages?.length
          ? true
          : false,
    },
    // {
    //   id: 5,
    //   title: "PG Start",
    //   time: logNetworks?.pgStart?.time || "",
    //   show:
    //     logNetworks?.tower &&
    //     logNetworks?.startJourney?.date &&
    //     logNetworks?.reachedLocation?.date &&
    //     // logNetworks?.entryImages?.length &&
    //     logNetworks?.pgStart?.time
    //       ? true
    //       : false,
    // },
    ...(logNetworks?.result?.length
      ? [
          {
            id: 7,
            title: "PG pause",
            timeArray: logNetworks?.result?.map((el) => (
              <div>
                Form {el?.restStartTime} to {el?.restEndTime}{" "}
                {el?.minutesOfRestTime || el?.minutesOfRestTime === 0
                  ? ` - ${el?.minutesOfRestTime} min`
                  : ""}
              </div>
            )),
            show:
              logNetworks?.pgStart?.time && logNetworks?.result?.length
                ? true
                : false,
          },
        ]
      : []),
    // {
    //   id: 6,
    //   title: "PG Off",
    //   time: logNetworks?.pgOff?.time || "",
    //   show:
    //     logNetworks?.tower &&
    //     logNetworks?.startJourney?.date &&
    //     logNetworks?.reachedLocation?.date &&
    //     // logNetworks?.entryImages?.length &&
    //     logNetworks?.pgStart?.time &&
    //     logNetworks?.pgOff?.time
    //       ? true
    //       : false,
    // },
    {
      id: 4,
      title: (
        <div className="flex items-center gap-2">
          <span>Verify Service - 2</span>
          {logNetworks?.existImages?.length ? (
            <div
              className={`status border-none ${
                true
                  ? "status-info cursor-pointer !text-white !bg-[#ccc]"
                  : "status-info !text-gray-400"
              }`}
              onClick={() =>
                setOpenImg({
                  open: true,
                  type: "EXIST",
                })
              }
            >
              View
            </div>
          ) : null}
        </div>
      ),
      pgCheck: logNetworks?.checkList?.map((el) => el?.name),
      show:
        logNetworks?.tower &&
        logNetworks?.startJourney?.date &&
        logNetworks?.reachedLocation?.date &&
        logNetworks?.pgOff?.time &&
        logNetworks?.entryImages?.length
          ? true
          : false,
    },
    {
      id: 5,
      title: "Exit request",
      date: logNetworks?.existPremises?.date
        ? formatDate(logNetworks?.existPremises?.date)
        : "",
      time: logNetworks?.existPremises?.time || "",
      show:
        logNetworks?.tower &&
        logNetworks?.startJourney?.date &&
        logNetworks?.reachedLocation?.date &&
        // logNetworks?.entryImages?.length &&
        logNetworks?.pgStart?.time &&
        logNetworks?.pgOff?.time &&
        logNetworks?.existPremises?.date
          ? true
          : false,
    },
  ];

  // console.log(logNetworks);

  // if(logNetworks?.result?.length) {
  //   timelineData.slice(5, 0, )
  // }

  const networkData = useCallback(() => {
    // dispatch(
    //   networkLogViewAsync({
    //     params: { id: ticketData?.towerTicketLogData?._id as string },
    //   })
    // );

    const id =
      type === "SINGLE_LIST"
        ? ticketData?._id
        : ticketData?.towerTicketLogData?._id;

    if (id) {
      dispatch(
        networkLogViewAsync({
          params: { id },
        })
      );
    }
  }, [type, ticketData?._id, ticketData?.towerTicketLogData?._id, dispatch]);

  useEffect(() => {
    networkData();
  }, [networkData]);

  useEffect(() => {
    generateToken();

    onMessage(messaging, (payload) => {
      const notification = payload?.notification;

      if (notification?.title === "map") {
        networkData();
      }
    });
  }, [networkData]);

  const currentLocation = {
    lat: logNetworks?.pgLat,
    lon: logNetworks?.pgLon,
  };
  const destination = {
    lat: logNetworks?.latitude,
    lon: logNetworks?.longitude,
  };

  const showMap =
    logNetworks?.pgLat &&
    logNetworks?.pgLon &&
    logNetworks?.longitude &&
    logNetworks?.latitude
      ? true
      : false;

  // console.log(ticketData);

  return (
    <CustomModal
      width={showMap ? 1100 : 850}
      handleClose={handleClose}
      {...rest}
    >
      {openImg?.open === true ? (
        <ViewImages
          open={openImg?.open}
          title="Verify Service Product"
          data={
            openImg.type === "ENTRY"
              ? {
                  entryImages: logNetworks?.entryImages,
                }
              : openImg?.type === "EXIST"
              ? { existImages: logNetworks?.existImages }
              : null
          }
          handleClose={() => setOpenImg(null)}
        />
      ) : null}

      {openSingleImg?.open === true ? (
        <ViewSingleImage
          open={openSingleImg?.open}
          title="Verify Service Product"
          data={
            openSingleImg.type === "STARTJOURNEY"
              ? {
                  entryImages: logNetworks?.startJourney?.photo,
                }
              : openSingleImg.type === "REACHEDLOCATION"
              ? {
                  entryImages: logNetworks?.reachedLocation?.photo,
                }
              : null
          }
          handleClose={() => setOpenSingleImg(null)}
        />
      ) : null}

      {open?.open && (
        <WorkDurationModal
          open={open}
          handleClose={toggle}
          data={{
            id:
              type === "SINGLE_LIST"
                ? ticketData?._id
                : ticketData?.towerTicketLogData?._id,
            perMinuteCharge: ticketData?.towerTicketLastData?.perMinuteCharge,
            sorOne: ticketData?.towerTicketLastData?.sorOne,
            totalAmount: logNetworks?.totalAmount,
          }}
        />
      )}
      <div
        className={`grid gap-2.5 ${
          showMap ? "md:grid-cols-3" : "md:grid-cols-2"
        }`}
      >
        <div>
          <div className="p-10 !pb-0 bg-gray-50 rounded-bl-2xl">
            <div className="flex justify-center items-center">
              <span
                className={`inline-flex justify-center items-center w-[54.56px] h-[54.56px] text-white rounded-full text-lg ${
                  timelineData?.[timelineData?.length - 1]?.show
                    ? "bg-primary-np"
                    : "bg-status-waiting-btn"
                }`}
              >
                <NetworkIcon width="28" height="28" />
              </span>
            </div>

            <h3 className="text-center text-header text-lg font-medium py-3">
              {`${capitalize(ticketData?.towerName)} - ${
                ticketData?.regionName
              }`}
            </h3>

            <ul className="rounded border border-zinc-200 border-solid bg-white">
              {locatorChildren || (
                <>
                  {ticketData?.numberOfOperation ? (
                    <LocatorListItem title="Ticket No : ">
                      {ticketData?.numberOfOperation || "-"}
                    </LocatorListItem>
                  ) : null}
                  <LocatorListItem title="Site ID:">
                    {ticketData?.siteCode || "N/A"}
                  </LocatorListItem>
                  {ticketData?.towerTicketLastData?.status ? (
                    <LocatorListItem title="Site Status">
                      <span
                        className={`status ${
                          ticketData?.towerTicketLastData?.status === "pending"
                            ? "status-pending"
                            : ticketData?.towerTicketLastData?.status ===
                              "accepted"
                            ? "status-done"
                            : ticketData?.towerTicketLastData?.status ===
                              "notaccepted"
                            ? "status-waiting"
                            : ticketData?.towerTicketLastData?.status ===
                              "cancel"
                            ? "status-danger"
                            : null
                        }`}
                      >
                        {ticketData?.towerTicketLastData?.status
                          ? capitalize(ticketData?.towerTicketLastData?.status)
                          : "N/A"}
                      </span>
                    </LocatorListItem>
                  ) : null}
                  {/* <LocatorListItem title="Structure Type:"></LocatorListItem> */}
                  <LocatorListItem title="Tower Name:">
                    {capitalize(ticketData?.towerName)}
                  </LocatorListItem>
                  <LocatorListItem title="Region:">
                    {ticketData?.regionName
                      ? ticketData.regionName
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")
                      : "N/A"}
                  </LocatorListItem>
                  <LocatorListItem title="Area:">
                    {ticketData?.areaName
                      ? ticketData?.areaName
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")
                      : "N/A"}
                  </LocatorListItem>
                  <LocatorListItem title="Territory:">
                    {ticketData?.teritoryName
                      ? ticketData?.teritoryName
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")
                      : "N/A"}
                  </LocatorListItem>
                  {/* <LocatorListItem title="Inactive Time:">
                    {logNetworks?.pgAlert?.startTime?.status === "start" &&
                    logNetworks?.pgAlert?.startTime?.time
                      ? moment(
                          logNetworks?.pgAlert?.startTime?.time,
                          "HH:mm:ss"
                        ).format("hh:mm:ss A")
                      : "N/A"}
                    <br />
                    {logNetworks?.pgAlert?.stopTime?.status === "stop" &&
                    logNetworks?.pgAlert?.stopTime?.time
                      ? moment(
                          logNetworks?.pgAlert?.stopTime?.time,
                          "HH:mm:ss A"
                        ).format("hh:mm:ss A")
                      : "N/A"}
                  </LocatorListItem> */}

                  {/* <LocatorListItem title="Electricity Status:">
                  {"N/A"}
                  <br />
                  {"N/A"}
                </LocatorListItem> */}
                </>
              )}

              {ticketData?.towerTicketLogData?.missCall ? (
                <>
                  <LocatorListItem title="Miss Call Time:">
                    {ticketData?.towerTicketLogData?.missCallTime}
                  </LocatorListItem>
                  <LocatorListItem title="Miss Call Note:">
                    {ticketData?.towerTicketLogData?.note || "N/A"}
                  </LocatorListItem>
                </>
              ) : null}
            </ul>
          </div>

          <div className="p-10 !pt-5 bg-gray-50 rounded-bl-2xl">
            <h3 className="text-center text-header text-lg font-medium py-3">
              PG RUN INFO
            </h3>

            {/* ==== Operator Buttons ==== */}
            <div className="mb-3 flex justify-start items-center gap-2">
              {logNetworks?.pgByOperator?.gp && (
                <Button
                  size="small"
                  type={selectedOperator === "gp" ? "primary" : "default"}
                  onClick={() => setSelectedOperator("gp")}
                >
                  GP
                </Button>
              )}

              {logNetworks?.pgByOperator?.robi && (
                <Button
                  size="small"
                  type={selectedOperator === "robi" ? "primary" : "default"}
                  onClick={() => setSelectedOperator("robi")}
                >
                  Robi
                </Button>
              )}
            </div>

            {/* ==== Data Section ==== */}
            {currentData && (
              <ul className="rounded border border-zinc-200 border-solid bg-white">
                <>
                  {currentData?.pgAlert?.startTime?.time && (
                    <LocatorListItem title="PG Alert Start Time: ">
                      {formatTo12Hour(currentData.pgAlert.startTime.time) ||
                        "N/A"}
                    </LocatorListItem>
                  )}

                  {currentData?.pgAlert?.stopTime?.time && (
                    <LocatorListItem title="PG Alert Off Time: ">
                      {currentData.pgAlert.stopTime.time || "N/A"}
                    </LocatorListItem>
                  )}

                  {currentData?.pgStart?.time && (
                    <LocatorListItem title="PG Actual Start Time: ">
                      {currentData.pgStart.time || "N/A"}
                    </LocatorListItem>
                  )}

                  {currentData?.pgOff?.time && (
                    <LocatorListItem
                      title={`PG Actual Off Time ${
                        currentData?.pgOff?.status === "forced"
                          ? "(Forced)"
                          : ""
                      }:`}
                    >
                      {currentData.pgOff.time || "N/A"}
                    </LocatorListItem>
                  )}

                  {(currentData?.rest?.length ?? 0) > 0 &&
                    currentData.rest.map((item: any) => (
                      <React.Fragment key={item._id}>
                        <LocatorListItem title="PG Rest Start Time: ">
                          {formatTo12Hour(item.startTime) || "N/A"}
                        </LocatorListItem>
                        <LocatorListItem title="PG Rest End Time: ">
                          {formatTo12Hour(item.endTime) || "N/A"}
                        </LocatorListItem>
                      </React.Fragment>
                    ))}
                </>
              </ul>
            )}
          </div>
        </div>

        <div
          className={`px-10 mt-10 pb-6 rounded-br-2xl ${
            showMap ? "grid md:grid-cols-2 gap-2.5 md:col-span-2" : ""
          }`}
        >
          <div>
            <Space
              className="table_column_title"
              size={0}
              direction="horizontal"
            >
              <Avatar size={45}>
                {firstChar(logNetworks?.PgData?.firstName)}
              </Avatar>
              {/* <Avatar src={IMG} size={45}></Avatar> */}
              <div className="ml-[8px]">
                <h5>{`${logNetworks?.PgData?.firstName || ""} ${
                  logNetworks?.PgData?.lastName || ""
                }`}</h5>
                <p className="mb-0.5">Email: {logNetworks?.PgData?.email}</p>
                <p>Mobile: {logNetworks?.PgData?.phoneNumber}</p>
              </div>
            </Space>

            <div className="border-b-[1.5px] border-solid border-t-0 border-x-0 border-others-gray pt-3 mb-5" />

            <Timeline
              className="px-1"
              items={timelineData?.map((el) => ({
                dot: (
                  <SuccessTimelineIcon
                    color={el?.show ? "#33AB29" : "#AFBACA"}
                  />
                ),
                children: (
                  <>
                    <h5 className="text-base font-medium text-body">
                      {el?.title}
                    </h5>
                    {el?.show ? (
                      <>
                        {el?.date || el?.time ? (
                          <div className="text-accent text-xs mt-1.5 leading-tight tracking-tight">
                            {el?.date ? `${el?.date} - ` : ""}
                            {el?.time}
                          </div>
                        ) : null}
                        {el?.pgCheck?.length ? (
                          <div className="block">
                            <ol className="mt-2 list-[lower-roman] list-inside">
                              {el?.pgCheck?.map((item, idx) => (
                                <li key={idx} className="text-accent">
                                  <span className="inline-flex items-center gap-1.5 text-xs font-normal leading-tight tracking-tight mt-0.5">
                                    {item}
                                  </span>
                                </li>
                              ))}
                            </ol>
                          </div>
                        ) : null}
                        {el?.timeArray?.length ? (
                          <div className="block">
                            <ol className="mt-2 list-[lower-roman] list-outside pl-2">
                              {el?.timeArray?.map((item, idx) => (
                                <li
                                  className="text-accent text-xs font-normal leading-tight tracking-tight"
                                  key={idx}
                                >
                                  {item}
                                </li>
                              ))}
                            </ol>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </>
                ),
                className: el?.show ? "timeline_active" : "timeline_inactive",
              }))}
            />
          </div>

          {showMap ? (
            <div>
              {viewLoading ? (
                <Loader />
              ) : currentLocation.lat &&
                currentLocation.lon &&
                destination.lat &&
                destination.lon ? (
                <DistanceCalculator
                  currentLocation={currentLocation}
                  destination={destination}
                />
              ) : null}
            </div>
          ) : null}

          <div>
            {type === "SINGLE_LIST" ? (
              <div className="px-3.5 py-2.5 mb-3 bg-gray-100 rounded-xl">
                <div className="flex justify-between items-center gap-2 mb-1">
                  <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
                    Total Duration:
                  </div>
                  <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
                    {logNetworks?.totalPGRunHour || 0} minutes
                    {/* {logNetworks?.totalValidRunTime || 0} minutes */}
                  </div>
                </div>
                <div className="flex justify-between items-center gap-2 mb-1">
                  <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
                    Rest in PG Duration:
                  </div>
                  <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
                    {logNetworks?.totalRestTime || 0} minutes
                  </div>
                </div>
                <div className="flex justify-between items-center gap-2 mb-1">
                  <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
                    Claimable Duration:
                  </div>
                  <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
                    {logNetworks?.totalValidRunTime || 0} minutes
                  </div>
                </div>

                <div className="flex justify-between items-center gap-2 mb-1">
                  <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
                    Total Site Down Time:
                  </div>
                  <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
                    {logNetworks?.totalSdTime || 0} minutes
                  </div>
                </div>

                <div className="flex justify-between items-center gap-2">
                  <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
                    Payable Bill:
                  </div>
                  <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
                    {logNetworks?.totalAmount || 0} BDT
                  </div>
                </div>
              </div>
            ) : (
              <Button block size="large" type="primary" onClick={handleOpen}>
                View work duration
              </Button>
            )}

            <div className="gray_btn mt-4" onClick={handleClose}>
              <Button block size="large">
                Back
              </Button>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
